import Axios from "../../../api/axios/Axios";

export const getNotifications = (limit = 20, offset = 0) =>
  Axios.get("/api/notifications", {
    params: { limit, offset },
  });

export const getUnreadCount = () =>
  Axios.get("/api/notifications/unread-count");

export const markNotificationAsRead = (notificationId) =>
  Axios.put(`/api/notifications/${notificationId}/read`);

export const markAllNotificationsAsRead = () =>
  Axios.put("/api/notifications/read-all");

export const getChannelFollowStatus = (username) =>
  Axios.get(`/api/notifications/follows/${encodeURIComponent(username)}`);

export const followChannel = (username) =>
  Axios.post(`/api/notifications/follows/${encodeURIComponent(username)}`);

export const unfollowChannel = (username) =>
  Axios.delete(`/api/notifications/follows/${encodeURIComponent(username)}`);
